import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=4df7d98e&"
import script from "./Winners.vue?vue&type=script&lang=js&"
export * from "./Winners.vue?vue&type=script&lang=js&"
import style0 from "./Winners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports